import React, { useState } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Clear } from "@mui/icons-material";
import "./CommonDateRangePicker.scss";

export default function DateTab(props) {
  const [value, setValue] = useState(props?.dateFrom ? [props?.dateFrom, props?.dateTo] : ["", ""]);

  const handleDateChange = (newValue) => {
    if (newValue === null) {
      setValue([null, null]);
      props?.onSelectDateRange(0);
    } else {
      setValue(newValue);
      props?.onSelectDateRange(newValue);
    }
  };

  return (
    <div>
      <div>
        <DateRangePicker
          onChange={handleDateChange}
          value={value}
          format="d MMM yy"
          className={`datePickerStyle disableinputPick ${!value?.[0] && "inActiveDatePickerStyle"}`}
          monthPlaceholder="MM"
          dayPlaceholder="DD"
          yearPlaceholder="YYYY"
          showLeadingZeros={false}
          clearIcon={value?.[0] && <Clear />}
          calendarIcon={<CalendarMonthOutlinedIcon />}
        />
      </div>
    </div>
  );
}
